module.exports = __webpack_public_path__ + "img/criticaledition_introduction_active.df8353a8.svg";